import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className='header-text'>
            <h1>Our Strong Teacher Team</h1>
            <p style={{ fontSize: "20px" }}>Add a summary that highlights your experience & supports your career development goals</p>
            <h2>Total Budget $ 5,00,000 US Dollar</h2>
        </div>
    );
};

export default Header;